import React, { useEffect, useState } from 'react'
import "./ErrorModal.css"
import ErrorIcon from "../../../assets/images/error.svg"
import { CloseCircle } from 'solar-icon-set/essentionalui'
import AdAccountModal from '../../AdAccountModal/AdAccountModal'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import UNIVERSAL from '../../../config/config'

const ErrorModal = ({campaign, setShowErrorModal}) => {
    const [ showAdModal,setShowAdModal] = useState(false)
    const [updated,setUpdated]=useState();
    const [userData, setUserData] = useState();
    const [allPages, setAllPages] = useState([]);
    const user = useSelector(state =>state.user.user)
    const [tokenInvalid, setTokenInvalid] = useState(false)

    
    useEffect(() => {
      async function getUserFbPages() {
        return fetch(UNIVERSAL.BASEURL_1 + '/bizv2/facebook/pages', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': '6gZ2J0WfUx9iAmKIwvwG3NiX1783yn094tzrssHe',
          },
          body: JSON.stringify({
            "business_id": String(user?.app_business_id),
            "next": ""
          })
        })
          .then((response) => response.json())
          .then((responseJson) => {
            console.log("pages api");
            if (responseJson.data) {
              setAllPages(responseJson.data.fb_pages);
              
            } else {
                if (responseJson?.error?.err_code === "TOKEN_INVALID") {
                    setTokenInvalid(true)
                  }else {
                    setTokenInvalid(false)
                  }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
      getUserFbPages();
    }, [])

    function handleFbConnect() {
        FB.login(
          function (response) {
            if (response.authResponse) {
              FB.api(`/me/permissions`, "GET", {}, function (res) {
                const allPermissions = check_permissions(res.data)
                if (allPermissions) {
                  get_account_pages(response.authResponse.userID, `/${response.authResponse.userID}/accounts?fields=id ,access_token, category, name, about, picture, cover, is_published, tasks, promotion_eligible,business`, [])
    
                  FB.api(`/${response.authResponse.userID}?fields=name,id,picture,email`, function (res) {
                    if (res) {
                      let data = { ...response.authResponse, ...res };
                      dispatch(fbActions.setFbDetails({ name: data.name, email: data.email, access_token: data.accessToken, is_long_lived_token: false, id: data.id }))
                      setShowFbPageModal(true);
                    }
                  })
                  setSelectPageModal(true)
                } else {
                  // SHOW PERMISSIONS NOT GRANTED
                  // FB.logout();
                  setPermissionModal(true)
                }
              })
            } else {
              console.log('User cancelled login or did not fully authorize.');
            }
          },
          {
            scope: 'pages_read_engagement, email, public_profile, pages_show_list, business_management, pages_manage_metadata',
            auth_type: 'rerequest',
          }
        );
      }
  
      const get_account_pages = (userID, url, pages) => {
        /* global FB */
        let tmp = pages
        FB.api(url, (res) => {
          if (res.data.length !== 0) {
            tmp = [...pages, ...res.data]
            const new_url = `/${userID}/accounts?fields=id ,access_token, category, name, about, picture, cover, is_published, tasks, promotion_eligible,business&after=${res.paging.cursors.after}`;
            get_account_pages(userID, new_url, tmp);
          } else {
            setAllPages(tmp)
          }
        })
        return;
      };
    
      const check_permissions = (data) => {
        let count = 0;
        const permissions = ["pages_read_engagement", "email", "public_profile", "pages_show_list", "business_management", "pages_manage_metadata"]
        data.map((item) => {
          if (permissions.includes(item.permission) && item.status === "granted") {
            count = count + 1
          }
        })
        return count === permissions.length ? true : false;
      }

      useEffect(() => {
        if (user?.app_business_id) {
          async function getUserProfile() {
            return fetch(UNIVERSAL.BASEURL_1 + "/biz/getBiz", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "x-api-key": "6gZ2J0WfUx9iAmKIwvwG3NiX1783yn094tzrssHe",
              },
              body: JSON.stringify({
                businessId: user?.app_business_id,
              }),
            })
              .then((response) => response.json())
              .then((responseJson) => {
                if (responseJson) {
                  setUserData(responseJson.data);
                } else {
                  // error
                }
              })
              .catch((error) => {
                console.log(error);
              });
          }
          getUserProfile();
        }
      }, [user, updated]);

  return (
    <div className='errorModal' >
        <div onClick={() => setShowErrorModal(false)} className='close'>
            <CloseCircle size={30} iconStyle='BoldDuotone' color='#00000066' />
        </div>
        <img src={ErrorIcon} />
        {campaign?.error_code === "token_invalid" && 
            <>
            <h4 className='errorModal-heading'>Unable to access Facebook account.</h4>
            <p className='errorModal-subHeading'>Unable to access your facebook account. User might have changed password account password. Relink or add new Facebook account.</p>
            </>
        }
        {campaign?.error_code === "fb_user_restricted" && 
            <>
            <h4 className='errorModal-heading'>Your advertising access is restricted.</h4>
            <p className='errorModal-subHeading'>You are no longer allowed to advertise your product on facebook. Facebook restricts users who violate its policies, resulting in limitations on account activities.</p>
            </>
        }
        {campaign?.error_code === "fb_page_restricted" && 
            <>
            <h4 className='errorModal-heading'>Page is restricted from advertising</h4>
            <p className='errorModal-subHeading'>Your page is no longer allowed to advertise your product on Facebook. Facebook restricts pages who violate it's policies, resulting in limitations on activities</p>
            </>
        }
        {campaign?.error_code === "fb_business_manager_not_created" && 
            <>
                <h4 className='errorModal-heading'>Business manager access denied.</h4>
                <p className='errorModal-subHeading'>Business Manager account doesn't have permission to access this page. Please click know more to see steps to solve this issue or choose another page.</p>
            </>
        }
        {campaign?.error_code === "business_whatsapp_not_linked" && 
            <>
                <h4 className='errorModal-heading'>Your ads are not running.</h4>
                <p className='errorModal-subHeading'>Please link your business whatsapp number to run your ads.</p>
            </>
        }
        {!campaign?.error_code && campaign?.stage === "WHATSAPP_REQUIRED" &&
            <>
                <h4 className='errorModal-heading'>Your ads are not running.</h4>
                <p className='errorModal-subHeading'>Please link your business whatsapp number to run your ads.</p>
             </>
        }
        {campaign?.error_code === "fb_page_restricted" &&  <button onClick={() =>setShowAdModal(true)}>Change page</button>}
        {campaign?.error_code === "token_invalid" &&  <button onClick={handleFbConnect}>Reauthenticate</button> }
        {campaign?.error_code === "business_whatsapp_not_linked"  && <Link style={{textDecoration: "none"}} to="/connect-whatsapp">
            <button>Link Business Whatsapp</button></Link> }
        {campaign?.error_code === "fb_user_restricted" && <button onClick={() =>setShowAdModal(true)}>Change page</button>}
        {campaign?.error_code === "fb_business_manager_not_created" && <div />}
        {!campaign?.error_code && campaign?.stage === "WHATSAPP_REQUIRED" &&
            <Link style={{textDecoration: "none"}} to="/connect-whatsapp"><button>Link Business Whatsapp</button></Link>
        }
        {showAdModal && <AdAccountModal tokenInvalid={tokenInvalid} showModal={showAdModal} userData={userData} user={user} pages={allPages} setShowAdModal={setShowAdModal} setUpdated={setUpdated} />}
    </div>
  )
}

export default ErrorModal